import React, { createContext, useState, useEffect, useContext } from 'react';
import axios from 'axios';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userPermissions, setUserPermissions] = useState([]);
  const [loading, setLoading] = useState(true);

  const checkSession = async () => {
    try {
      const response = await axios.get('/session-api/check-session', { withCredentials: true });
      if (response.data.isAuthenticated) {
        setIsAuthenticated(true);
        setUserPermissions(response.data.permissions);
      } else {
        setIsAuthenticated(false);
        setUserPermissions([]);
      }
      setLoading(false);
    } catch (error) {
      console.error('Error checking session:', error);
      setIsAuthenticated(false);
      setUserPermissions([]);
      setLoading(false);
    }
  };

  useEffect(() => {
    checkSession();
  }, []);

  return (
    <AuthContext.Provider value={{ isAuthenticated, userPermissions, loading, checkSession }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};
